import type { EReportColumnKey } from '~/presentation/reports/common/ReportFilter/types';

import {
  DEFAULT_SELECTED_COLUMNS_FOR_EXPERIMENT,
  ORDER_COLUMN_MAPPING,
  ORDER_COLUMNS_CONFIG_VERSION,
} from '../constants';
import { persist } from 'zustand/middleware';
import { create } from 'zustand';

export interface IOrderColumnsSelectorStoreState {
  isChangeSelectedColumnsPreviously: boolean;
  setIsChangeSelectedColumnsPreviously: (isChangeSelectedColumnsPreviously: boolean) => void;
  selectedColumns: EReportColumnKey[];
  columnsOrder: EReportColumnKey[];
  setSelectedColumns: (selectedColumns: EReportColumnKey[]) => void;
  setColumnsOrder: (columnsOrder: EReportColumnKey[]) => void;
}

export const useOrderColumnsSelectorStore = create<IOrderColumnsSelectorStoreState>()(
  persist(
    (set) => ({
      isChangeSelectedColumnsPreviously: false,
      setIsChangeSelectedColumnsPreviously: () => set({ isChangeSelectedColumnsPreviously: true }),
      selectedColumns: DEFAULT_SELECTED_COLUMNS_FOR_EXPERIMENT,
      columnsOrder: Object.values(ORDER_COLUMN_MAPPING).map((column) => column.value),
      setColumnsOrder: (columnsOrder) => set({ columnsOrder }),
      setSelectedColumns: (selectedColumns) => set({ selectedColumns }),
    }),
    {
      name: 'order-listing-columns-config',
      version: ORDER_COLUMNS_CONFIG_VERSION,
      // Returning nothing to merge leaves the defaults above in place
      migrate: () => ({}) as IOrderColumnsSelectorStoreState,
    },
  ),
);
